import {Component, Injector, Input} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {BaseComponent} from '../../../shared/components/base.component';

@Component({
  templateUrl: './add-icon-dialog.component.html',
  styleUrls: ['./add-icon-dialog.component.scss']
})
export class AddIconDialogComponent extends BaseComponent {

  @Input() selectedIcon: string;
  @Input() title: string;
  constructor(protected injector: Injector,
              private dialogRef: NbDialogRef<AddIconDialogComponent>) {
    super(injector);
  }

  /**
   * Marks the given icon as selected.
   * @param icon the selected icon
   * */
  onIconSelected(icon) {
    this.selectedIcon = icon;
  }

  /**
   * Closes dialog with selected icon.
   * */
  public save() {
    this.dialogRef.close(this.selectedIcon);
  }
}
